/**
 * The NISG 2026 self-check (components/ui/NisgCheck): a first, rough answer
 * to "does the law apply to us?" from sector, size and the special cases.
 * Mirrors the NIS 2 size-cap rule: medium and large entities in the listed
 * sectors are covered, large ones in annex 1 count as essential; a few
 * providers are covered regardless of size; everyone else is at most
 * pulled in through the supply chain. Kept free of UI so it can be tested.
 */

export type Sector = 'essential' | 'important' | 'none'
export type Size = 'small' | 'medium' | 'large'

export type Answers = {
  sector: Sector | ''
  size: Size | ''
  /** DNS, TLD registries, trust services, public communications networks: covered at any size */
  special: boolean
  /** supplies companies that are covered */
  supplier: boolean
}

export type Verdict = 'essential' | 'important' | 'special' | 'supplier' | 'none'

export function classify(a: Answers): Verdict | null {
  if (a.special) return 'special'
  if (!a.sector || !a.size) return null
  if (a.sector === 'essential' && a.size === 'large') return 'essential'
  if (a.sector !== 'none' && a.size !== 'small') return 'important'
  return a.supplier ? 'supplier' : 'none'
}
